// extracted by mini-css-extract-plugin
export default {"footer":"security_page_footer__oF9Qh"};